import { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import "../../styles/healthCheck.scss";
import Utility from "../../utility/Utility";
import { cdrAccess, keycloakCall, pcpCall, pcpoCall } from "../../services/HealthCheckService";

export default function HealthCheck() {
  const [keycloak, setKeycloak] = useState<any>();
  const [cdr, setCDR] = useState<any>();
  const [pcpo, setPCPO] = useState<any>();
  const [pcp, setPCP] = useState<any>();

  useEffect(() => {
    async function apiResponse() {
      const keycloakResponse = await keycloakCall()
      setKeycloak(keycloakResponse);
      const cdrResponse = await cdrAccess()
      setCDR(cdrResponse);
      const pcpResponse = await pcpCall()
      setPCP(pcpResponse);
      const pcpoResponse = await pcpoCall()
      setPCPO(pcpoResponse)
    }
    apiResponse()
  }, [])

  let healthCheckObj = [
    {
      serviceName: "Keycloak",
      api: Utility.env?.REACT_APP_KEYCLOAK_URL + '/realms/internal/.well-known/openid-configuration',
      status: keycloak,
      critical: "Yes",
    },
    {
      serviceName: "CDR",
      api: Utility.env?.REACT_APP_API_BASE_URL + '/fhir/EODB/Patient',
      status: cdr,
      critical: "Yes",
    },
    {
      serviceName: "PCP",
      api: Utility.env?.REACT_APP_PCP_LAUNCH_REDIRECT_URL.replace("/callback?auth=keycloak&lang=:lang", ""),
      status: pcp,
      critical: "Yes",
    },
    {
      serviceName: "PCPO",
      api: Utility.env?.REACT_APP_API_BASE_URL + "/fhir/EODB/.well-known/smart-configuration",
      status: pcpo,
      critical: "Yes",
    },
  ];

  return (
    <div className="container">
      <HealthCheckHeader />
      <div className="container healthCheck">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th id={"serviceHeader"}>SERVICE</th>
              <th id={"detailsHeader"}>DETAILS</th>
              <th id={"statusHeader"}>STATUS</th>
              <th id={"criticalHeader"}>CRITICAL</th>
            </tr>
          </thead>

          <tbody>
            {healthCheckObj.map((value: any, index: number) => {
              return (
                <tr key={value.serviceName}>
                  <td id={`${index}${value.serviceName}`}>{value.serviceName}</td>
                  <td id={`${index}_apiDetails`}>{value.api}</td>
                  <td
                    id={`${index}${value.status}`}
                    className={value.status === "Success" ? "green" : "red"}
                  >
                    {value.status}
                  </td>
                  <td id={`${index}${value.critical}`}>{value.critical}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <HealthCheckFooter />
    </div>
  );
}

export const HealthCheckHeader = () => {
  return (
    <div className="col-6 text-start header">
      <a className={"logo"}>
        <img alt="logo" src="/logo.svg" />
        <img alt="logo-name" src="/logo_name.svg" />
      </a>
    </div>
  );
};

export const HealthCheckFooter = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-2 text-start">
            <div className={"logo"}>
              <img alt="logo" src="/logo.svg" />
              <img alt="logo-name" src="/logo_name.svg" />
            </div>
          </div>
          <div className="col-md-6 text-md-center text-sm-start">
            <span>Copyrights@2022</span>
          </div>

          <div className="col-md-1 text-md-end text-sm-start">
            <img alt="logo" src="/relx-logo.svg" width={"80px"} />
          </div>
        </div>
      </div>
    </div>
  );
};

